var styles = {
  "Container": "_Container_no9uw_1"
};

export { styles as default };
